import { render, staticRenderFns } from "./record.vue?vue&type=template&id=7cec975a&scoped=true&"
import script from "./record.vue?vue&type=script&lang=ts&"
export * from "./record.vue?vue&type=script&lang=ts&"
import style0 from "./record.vue?vue&type=style&index=0&id=7cec975a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cec975a",
  null
  
)

export default component.exports